"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_number_1 = require("./is-number");
var isOdd = function (num) {
    return is_number_1.default(num) && num % 2 !== 0;
};
exports.default = isOdd;
//# sourceMappingURL=is-odd.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@antv/util/lib/is-odd.js
// module id = 1124
// module chunks = 37